export const BY_NONE = 0
export const BY_PHONE_NUMBER = 1
export const BY_IP_PHONE = 2
export const BY_BROWSER = 3
